<template>
  <FormGroup :label="label" :input-id="idCalc" :errors="errorsCalc" :successes="successes">
    <div class="d-flex justify-content-center popular-apps">
      <template v-for="app in popularApps">
        <input
          type="radio"
          style="display: none;"
          :key="app"
          :class="{ 'is-invalid': errorsCalc, 'is-valid': successes }"
          :data-test="testId"
          :id="`${idCalc}-${app}`"
          :name="name"
          :placeholder="placeholder"
          :value="app"
          @change="selectApp"
        />
        <label
          :key="`${app}-label`"
          :for="`${idCalc}-${app}`"
          class="popular-app text-center flex-grow-1 p-2 m-2"
        >
          <Logo :logo="app" :size="130" />
          <h2 class="text-primary mt-2">{{ $t(`global.${app}`) }}</h2>
        </label>
      </template>
    </div>
  </FormGroup>
</template>

<script>
import FormGroup from "@/components/display/form/FormGroup";
import FormMixin from "@/components/display/form/FormMixin";
import Logo from "@/components/display/Logo";

export default {
  name: "FormPopularAppSelect",
  components: {
    Logo,
    FormGroup,
  },
  mixins: [FormMixin],
  props: {
    value: [Number, String],
    apps: Array,
    popularApps: {
      type: Array,
      validator: function (value) {
        if (!Array.isArray(value)) {
          return false;
        }
        return value.filter((item) => typeof item !== "string").length === 0;
      },
    },
  },
  setup(props, { emit }) {
    const selectApp = (e) => {
      const appType = e.target.value;
      const app = props.apps.find((a) => a.type === appType);
      emit("input", app.id);
    };

    return { selectApp };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";

.popular-app {
  background-color: rgb(0, 191, 255, 0.05);
  border: 2px solid rgba(0, 174, 239, 0.05);
}

.popular-app:hover {
  background-color: rgb(229, 246, 253);
  border-color: #002e4c;
}
</style>
